import { gql } from "@apollo/client";

export const ADD_ORGANIZATION_MUTATION = gql`
  mutation InsertOrganization(
    $object: organization_insert_input = { domain: "", name: "test1" }
  ) {
    insert_organization_one(object: $object) {
      domain
      id
      name
    }
  }
`;

export const MUTATION_SEND_ACC_SUBSCRIPTION_LEVEL_EMAIL_INVITE = gql`
  mutation MyMutation(
    $user_id: String!
    $permission_id: Int
    $invited_user_company_id: String!
  ) {
    resend_email_invite(
      invited_user_id: $user_id
      invited_user_subscription_permission_id: $permission_id
      invited_user_company_id: $invited_user_company_id
    ) {
      message
    }
  }
`;

export const MUTATION_ADMIN_INSERT_SUBSCRIPTION_USER = gql`
  mutation AdminInsertSubscriptionUser(
    $company_id: String!
    $email: String!
    $first_name: String!
    $last_name: String!
    $password: String!
    $subscription_id: String!
    $phone: String
    $subscription_permission_id: Int!
  ) {
    admin_insert_subscription_user(
      userData: {
        company_id: $company_id
        email: $email
        first_name: $first_name
        last_name: $last_name
        password: $password
        subscription_id: $subscription_id
        phone: $phone
        subscription_permission_id: $subscription_permission_id
      }
    ) {
      message
      failures
    }
  }
`;

export const MUTATION_ADMIN_INSERT_PROJECT_USER = gql`
  mutation AdminInsertProjectUser(
    $company_id: String!
    $email: String!
    $first_name: String!
    $last_name: String!
    $password: String!
    $subscription_id: String!
    $project_id: String!
    $project_permission_id: Int!
    $user_type_id: Int!
    $phone: String
  ) {
    admin_insert_subscription_user(
      userData: {
        company_id: $company_id
        email: $email
        first_name: $first_name
        last_name: $last_name
        password: $password
        subscription_id: $subscription_id
        project_id: $project_id
        project_permission_id: $project_permission_id
        user_type_id: $user_type_id
        phone: $phone
      }
    ) {
      message
      failures
    }
  }
`;

export const MUTATION_INSERT_USERS_TO_PROJECT_SUBSCRIPTION = gql`
  mutation InsertProjectUsers(
    $users: [userProjectDataArray]
    $projectId: String
    $triggerMail: Boolean = true
  ) {
    insert_project_users_multi(
      triggerMail: $triggerMail
      userData: $users
      projectId: $projectId
    ) {
      message
    }
  }
`;

export const CREATE_SUBSCRIPTION_MUTATION = gql`
  mutation CreateSubscription(
    $organization_id: uuid!
    $email: String!
    $name: String!
  ) {
    insert_subscription_one(
      object: {
        organization_subscriptions: {
          data: { organization_id: $organization_id }
        }
        name: $name
        subscription_users: {
          data: {
            subscription_permission_id: 1
            user: {
              data: { email: $email }
              on_conflict: {
                update_columns: [updated_at]
                constraint: user_email_key
              }
            }
          }
        }
      }
    ) {
      id
      name
    }
  }
`;
